// @flow
import pick from "lodash/pick";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import type { PreferencesState, ReduxState } from "../redux/types";

const getPreferences = (state: ReduxState) => state.preferences;
const getPreferenceNames = (
  state: ReduxState,
  preferenceNames: string | Array<string>,
) => (Array.isArray(preferenceNames) ? preferenceNames : [preferenceNames]);

const selectPreference = createSelector(
  [getPreferences, getPreferenceNames],
  (preferences, preferenceNames) => {
    return pick(preferences, preferenceNames);
  },
);

/**
 */
export const usePreference = (
  preferenceNames: string | Array<string>,
): PreferencesState => {
  return useSelector((state) => selectPreference(state, preferenceNames));
};
